<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 批量状态更新
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="BtnSmPurple" @click="handleAll">批量更新</button>
        </div>
        <div class="searchForm1">
          <searchForm
            :items="items"
            :formPlus="form_jsgl"
            ref="searchForm_jsgl"
          >
            <template slot="last">
              <el-form-item label="设备名称">
                <el-input
                  placeholder="请输入设备名称"
                  v-model="seefrom.deviceName"
                ></el-input>
              </el-form-item>
              <el-form-item label="设备编码">
                <el-input
                  placeholder="请输入设备编码"
                  v-model="seefrom.deviceMark"
                ></el-input>
              </el-form-item>
              <el-form-item label="应用系统" prop="system_id">
                <el-select
                  :popper-append-to-body="false"
                  v-model="seefrom.system_id"
                  placeholder="请选择应用系统"
                  @change="selectDeviceType"
                >
                  <el-option
                    v-for="item in SystemId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select
                  :popper-append-to-body="false"
                  placeholder="请输入设备类型"
                  v-model="seefrom.deviceType"
                >
                  <el-option :value="''">请选择</el-option>
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.typeName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <br />
              <!-- <el-form-item label="设备型号">
                <el-input
                  placeholder="请输入设备型号"
                  v-model="seefrom.model"
                ></el-input>
              </el-form-item>
              <el-form-item label="设备状态">
                <el-select
                  placeholder="请输入设备状态"
                  v-model="seefrom.status"
                  :popper-append-to-body="false"
                >
                  <el-option :value="''">请选择</el-option>
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="区域选择">
                <el-input
                  placeholder="请选择区域"
                  v-model="seefrom.curAreaName"
                  @focus="changeAreaMode(1)"
                ></el-input>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="extra/deviceStatus/findList"
            :parent="self"
            :config="config"
            :other="other"
            ref="deviceList"
          >
            <template slot="last">
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconcheck"
                    type="text"
                    size="small"
                    @click="seeAll(scope.$index, scope.row)"
                    >上线</el-link
                  >
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- 弹出框 -->

        <!-- 区域树 -->
        <mountPoint
          :hasChildNodes="areaTreeMode"
          :dialogVisible="areaTreeVisible"
          @regionTreeClose="areaTreeVisible = false"
          @regionTreeData="selRegionData"
        ></mountPoint>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      ifSuccess: false,
      rules: {
        device_mark: [
          { required: true, message: "请输入设备编码", trigger: "blur" },
        ],
        type: [{ required: true, message: "请输入设备类型", trigger: "blur" }],
        name: [{ required: true, message: "请输入设备名称", trigger: "blur" }],
        system_id: [
          { required: true, message: "请输入应用系统", trigger: "blur" },
        ],
        factory: [
          { required: true, message: "请输入生产厂商", trigger: "blur" },
        ],
        model: [{ required: true, message: "请输入设备型号", trigger: "blur" }],
        // imsi: [
        //   { required: true, message: "请输入设备IMSI", trigger: "blur" }
        // ],
        regionName: [
          { required: true, message: "请选择安装点", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入安装位置", trigger: "blur" },
        ],
      },
      selectLink: [
        { id: "1", label: "设备主动" },
        { id: "0", label: "平台主动" },
      ],
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      editDialogVisible: false,
      showTable: true,
      other: {
        ...this.seefrom,
      },
      //弹出框标题
      title: "",
      title1: "设备新增状态",
      //加载标识
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      //查询弹框是否显示
      infoDialogVisible: false,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
      //设备额外信息
      equipment: {
        protocolTypeName: "",
      },
      //分页
      message: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      //新增修改查看条框是否显示下面的按钮
      seeBtn: true,
      //新增还是修改
      state: null,
      //设备列表数据
      tableData2: [],
      //设备类型数组
      options: [],
      Options: [],
      //通道列表
      channels: [],
      channelsCopy: [],
      //消防泵类型列表 废弃
      pumpTypes: [],
      //设备厂家列表
      factoryList: [],
      //设备型号列表
      deviceModeList: [],
      //数据流列表
      dataFlows: [],
      //DTU列表
      dtuList: [],
      //搜索表单
      seefrom: {
        deviceName: "",
        deviceMark: "",
        system_id: "",
        deviceType: "",
        model: "",
        status: 2,
        curAreaName: "",
        region_id: "",
      },
      //新增修改查看设备信息
      addEquipment: {
        expire_time: "",
        system_id: "",
        id: null,
        name: "",
        device_mark: "",
        model: "",
        type: "",
        deviceType: "",
        factory: "",
        factoryId: null,
        imsi: "",
        region: "",
        regionName: "",
        address: "",
        regions: "",
        selChannel: "",
        pumpType: null,
        dtuId: null,
        //绑定通道
        bindChannels: [],
        protocolType: "",
        //设备协议
        select_link: "",
        device_ip: "",
        register_message: "",
        mqtt_uname: "",
        mqtt_pwd: "",
        fileList: [],
      },
      loadingStatus: false,
      newAddId: 0,
      items: [],
      SystemId: [],
      //设备种类（网关）
      deviceKind: "",
      showDeviceMark: false,
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "deviceName",
          label: "设备名称",
        },
        {
          prop: "deviceMark",
          label: "设备编码",
        },
        {
          prop: "deviceTypeName",
          label: "设备类型",
        },
        {
          prop: "region",
          label: "所属区域",
        },
        {
          prop: "model",
          label: "设备型号",
        },
        {
          prop: "factory",
          label: "生产厂商",
        },
        {
          prop: "deviceStatusName",
          label: "设备状态",
        },
        {
          prop: "systemName",
          label: "应用系统",
        },

        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
    urls() {
      if (!this.addEquipment.fileList) return;
      return this.addEquipment.fileList;
      // .map((o) => `http://39.100.67.126:1212/file/${o.response.data[0]}`)
      // .join(";");
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
    mountPoint: () => import("public/mountPoint"),
    downloadBtn: () => import("public/download"),
  },
  methods: {
    getOwnerName(row, column) {
      if (row.owerVO) {
        return row.owerVO.name;
      } else {
        return "";
      }
    },
    changeEvent(e) {
      this.$forceUpdate();
    },
    selectDeviceType(value) {
      this.addEquipment.type = "";
      this.addEquipment.protocolType = "";
      this.$axiosget("manager/operatingSystemApi/getDeviceTypeByOperatingId", {
        params: {
          id: value,
        },
      }).then((res) => {
        this.options = res.data.data;
      });
    },
    initSystemId() {
      //console.log("应用系统");
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId",
        {
          params: {
            compayId: localStorage.getItem("companyId"),
          },
        }
      ).then((res) => {
        this.SystemId = res.data.data;
      });
    },
    initDeviceFactory() {
      let params = {
        key: "FACTORY",
        pageSize: 99,
        pageNum: 1,
      };
      this.$axiosget("operation/dictionaryType/queryList", {
        params: params,
      }).then((res) => {
        if (res.data.status === "10000") {
          this.factoryList = res.data.data.list;
        } else {
          this.factoryList = [];
        }
      });
    },
    initDeviceMode(factoryID, deviceModeId) {
      this.addEquipment.model = deviceModeId ? this.addEquipment.model : null;
      this.addEquipment.pumpType = deviceModeId || null;
      let factoryId = factoryID || this.addEquipment.factoryId;
      let temp = this.factoryList.find((it) => it.id === factoryId);
      if (temp) {
        this.addEquipment.factory = deviceModeId
          ? this.addEquipment.factory
          : temp.name;
      }
      let params = {
        dicType: this.addEquipment.factoryId,
      };
      this.$axiosget("operation/dictionaryData/queryList", {
        params: params,
      }).then((res) => {
        if (res.data.status === "10000") {
          let list = res.data.data.list;
          this.deviceModeList = list;
          if (deviceModeId) {
            let model = list.find((it) => it.id === deviceModeId);
            if (model)
              this.addEquipment.model = this.addEquipment.model || model.name;
          }
        } else {
          this.deviceModeList = [];
        }
      });
    },
    //设备类型选择变更
    changeEquipment(val) {
      this.equipment = this.options.find((e) => val === e.id);
      //判断设备种类
      this.deviceKind = this.equipment.deviceKind;
      this.addEquipment.protocolType = this.equipment.protocolType;
      if (this.equipment.deviceKind === 2) {
        this.showDeviceMark = false;
      } else {
        this.showDeviceMark = true;
      }

      this.addEquipment.select_link = "";
      this.addEquipment.device_ip = "";
      this.addEquipment.register_message = "";
      this.addEquipment.mqtt_uname = "";
      this.addEquipment.mqtt_pwd = "";
    },
    deviceModeChange() {
      let deviceMode = this.addEquipment.pumpType;
      let temp = this.deviceModeList.find((it) => it.id === deviceMode);
      if (temp) {
        this.addEquipment.model = temp.name;
      }
    },
    //查询设备型号信息
    queryDeviceMode(id) {
      this.$axiosget("operation/dictionaryData/querySingle", {
        params: { id: id },
      }).then((res) => {
        if (res.data.status === "10000") {
          let temp = res.data.data;
          if (temp.dicTypeId) {
            this.addEquipment.factoryId = temp.dicTypeId;
            this.initDeviceMode(temp.dicTypeId, id);
          }
        }
      });
    },
    seeAll(index, row) {
      var formData = new FormData();
      formData.append("id", row.id);
      this.$axiospost("extra/deviceStatus/updateStatus", formData).then(
        (res) => {
          if (res.data.status == 10000) {
            this.subSeefrom();
            this.$message.success("上线成功！");
          }
        }
      );
    },
    // 批量更新
    handleAll() {
      this.$confirm("是否确定批量处理？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        //console.log(this.seefrom)
        var formData = new FormData();
        formData.append("system_id", this.seefrom.system_id);
        formData.append("region_id", this.seefrom.region_id);
        formData.append("deviceMark", this.seefrom.deviceMark);
        formData.append("deviceType", this.seefrom.deviceType);
        formData.append("deviceName", this.seefrom.deviceName);
        this.$axiospost("extra/deviceStatus/updateStatusAll",formData).then((res) => {
          this.subSeefrom();
          this.$message.success("成功上线" + res.data.data + "个设备！");
        });
      });
    },
    //搜索
    subSeefrom() {
      this.other = this.seefrom;
      this.$refs.deviceList.pageToOne();
      this.$nextTick(this.$refs.deviceList.getData);
    },
    //重置
    reset() {
      // this.seefrom.deviceName = "";
      // this.seefrom.device_mark = "";
      // this.seefrom.value = "";
      // this.seefrom.status = "";
      // this.seefrom.model = "";
      // this.seefrom.curAreaName = "";
      // this.seefrom.region_id = "";
      // this.seefrom.system_id = null;
      this.seefrom = {
        deviceName: "",
        deviceMark: "",
        system_id: "",
        deviceType: "",
        model: "",
        status: 2,
        curAreaName: "",
        region_id: "",
      };
      this.options = [];
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.seefrom.region_id = a.id;
        this.seefrom.curAreaName = a.name;
      } else if (mode === 2) {
        if (!a.type || a.type !== 1) {
          this.$set(this.addEquipment, "region", null);
          this.addEquipment.regionName = "";
          return;
        }
        this.$set(this.addEquipment, "region", a.id);
        this.addEquipment.regionName = a.name;
      }
    },
  },
  mounted() {
    this.initDeviceFactory();
    this.initSystemId();
  },
};
</script>

<style lang="less">
.content {
  .w_normalNav {
    padding-top: 10px;
    height: 52px;
    position: absolute;
    top: -52px;
    right: 32px;
    // z-index: 99;
  }
  .el-input__inner:focus {
    border: 1px solid #3587c7;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/statusUpdate/index.vue